import React from 'react';
import T from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames/bind';
import ReportActivityRow from './ReportActivityRow';
import styles from './ReportActivity.module.scss';

const cn = classnames.bind(styles);

const ReportActivityList = ({ logs }) => {
  if (!logs?.length) {
    return (
      <div className={cn('empty')}>
        <FormattedMessage id="general.noReportActivity" />
      </div>
    );
  }

  return (
    <div className={cn('list')}>
      {logs.map((log) => (
        <ReportActivityRow key={log.id} log={log} />
      ))}
    </div>
  );
};

ReportActivityList.propTypes = {
  logs: T.arrayOf(T.object),
};

ReportActivityList.defaultProps = {
  logs: [],
};

export default ReportActivityList;
